import React, { useState } from 'react';
import PropTypes from 'prop-types'
import RitSelect from '../RitSelect';

const DetailFilter = ({ availableStyles, handleFilterChange, handleFilterClear, isMobile, selectedStyle }) => {

    const defaultStyle = selectedStyle;

    const [value, setValue] = useState(defaultStyle)

    const onChange = (item) => {
        setValue(value);
        if (Boolean(item)) {
            handleFilterChange(item.id)
        } else {
            setValue(defaultStyle);
        }
    }


    const filter = availableStyles.map((s) => (
        {
            name: s.displayName,
            value: s
        }
    ));

    return (
        <div className='config-options-wrapper__detail-filter'>
            <div className='config-options-wrapper__title'>
                СТИЛЬ
            </div>
            
            <div className='config-options-wrapper__select-wrapper'>
                <RitSelect
                    defaultText={'Выберите стиль'}
                    value={value}
                    onChange={onChange}
                    optionsList={filter}
                >
                </RitSelect>
            </div>
        </div>);
}

DetailFilter.propTypes = {
    availableStyles: PropTypes.array.isRequired,
    handleFilterChange: PropTypes.func.isRequired,
    handleFilterClear: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
    selectedStyle: PropTypes.object.isRequired,
}

export default DetailFilter;